/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      currentPage: 1,
    };
  },
  watch: {
    $route: {
      async handler() {
        if (this.$route.query.page) {
          this.currentPage = Number(this.$route.query.page);
        } else {
          this.currentPage = 1;
        }
        await this.loadInfo();
        await this.fetchListData();
      },
      immediate: true,
    },
    currentPage: {
      handler() {
        if (!this.$route.query.page && this.currentPage === 1) {
          return;
        }
        this.$router.push({ query: { page: this.currentPage } });
      },
    },
  },
  methods: {
    ...mapActions({
      loadInfo: 'user/loadInfo',
    }),
  },
};
